// Przycisk dodawania pozycji do listy zakupowej

import React, { FC, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import classnames from 'classnames';

import { IPrice, IUnit } from 'api/types';
import { JournalText } from 'react-bootstrap-icons';
import { Modal } from 'components/controls';
import { AddToShoppingListForm } from 'components/containers';

import styles from 'theme/components/containers/AddToShoppingListButton/AddToShoppingListButton.module.scss';
import { useRWD } from 'hooks';

// typ danych wejściowych
interface IProps {
  unit?: IPrice | IUnit;
  quantity: number;
  openModal?: boolean;
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>;
  product_id?: number;
  unit_id?: number;
  image?: string;
  title?: string;
  index?: string;
  currency?: string;
}

const AddToShoppingListButton: FC<IProps> = ({
  // product,
  unit,
  quantity,
  openModal,
  setOpenModal,
  product_id,
  unit_id,
  image,
  title,
  index,
  currency
}) => {
  const { t } = useTranslation();
  const { isMobile } = useRWD();

  // czy jest modal dodawania do listy zakupowej
  const [isAddToShoppingListModal, setIsAddToShoppingListModal] = useState(false);

  // czy wszystkie dane są podane

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Containers-AddToShoppingListButton'
      )}>
      <div
        className={styles.shoppingListButton}
        onClick={() => {
          setOpenModal ? setOpenModal(true) : setIsAddToShoppingListModal(true);
        }}>
        <JournalText />
        <Trans>Dodaj do listy</Trans>
      </div>

      {(openModal || isAddToShoppingListModal) && (
        <Modal
          fullScreen={isMobile}
          title={t('Dodawanie produktów do listy zakupowej')}
          onClose={() => {
            setOpenModal ? setOpenModal(false) : setIsAddToShoppingListModal(false);
          }}>
          <AddToShoppingListForm
            items={[
              {
                quantity: quantity,
                price_net_formatted: unit?.price_net_formatted,
                price_gross_formatted: unit?.price_gross_formatted,
                product_id: product_id,
                unit_id: unit_id,
                image: image,
                title: title,
                index: index,
                currency: currency
              }
            ]}
            onCancel={() => {
              setOpenModal ? setOpenModal(false) : setIsAddToShoppingListModal(false);
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default AddToShoppingListButton;
